import { ArrowIcon } from '@avila-tek/ui/src';

function SliderButton(props) {
  const { className, classNameIcon, onClick } = props;
  return (
    <button type="button" className={className} onClick={onClick} tabIndex={0}>
      <ArrowIcon className={classNameIcon} />
    </button>
  );
}

export default SliderButton;
